/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { BuilderFormSchemaFactory, FormRootSchema, FormStateSchema } from '@gh/builder-shared';
import { DateTimeTypes, FormState, toAppFormArray } from '@gh/common-shared';
import { getControl } from '@gh/core-ui';
import { uniqueId } from 'lodash';
import { ContactDetailsCustomerAdditionalDetails } from '../../resources/model/contact-details-customer.model';

@Injectable()
export class ContactDetailsCustomerAdditionalDetailsFormState extends FormState<ContactDetailsCustomerAdditionalDetails> {
  constructor(schemaFactory: BuilderFormSchemaFactory) {
    super(schemaFactory);
  }

  addKid(): void {
    const { group } = this.schema;
    const array = toAppFormArray(getControl(this.group, 'additionalDatesOfBirth.kids'));
    array.push(group({
      key: uniqueId('kid:'),
      children: {
        name: void 0,
        dateOfBirth: { type: DateTimeTypes.ShortDate },
      },
    }).build());
    array.markAsDirty();
  }

  removeKid(index: number): void {
    const array = toAppFormArray(getControl(this.group, 'additionalDatesOfBirth.kids'));
    array.removeAt(index);
    array.markAsDirty();
  }

  protected buildSchema(details: ContactDetailsCustomerAdditionalDetails,
                        { root, group, array }: FormStateSchema): FormRootSchema {
    const { additionalDatesOfBirth } = details;

    return root({
      children: {
        dateOfBirth: { type: DateTimeTypes.ShortDate },
        websiteLead: void 0,
        additionalDatesOfBirth: group({
          children: {
            partnerName: void 0,
            partnerDateOfBirth: { type: DateTimeTypes.ShortDate },
            parent1Name: void 0,
            parent1DateOfBirth: { type: DateTimeTypes.ShortDate },
            parent2Name: void 0,
            parent2DateOfBirth: { type: DateTimeTypes.ShortDate },
            kids: array({
              children: (additionalDatesOfBirth && additionalDatesOfBirth.kids || []).map(() => group({
                key: uniqueId('kid:'),
                children: {
                  name: void 0,
                  dateOfBirth: { type: DateTimeTypes.ShortDate },
                },
              })),
            }),
          },
        }),
      },
    });
  }
}
